import { format } from 'date-fns';

import { DateTimeCellProps } from './date-time-cell.component';

interface ViewProps {
    date?: string;
    time?: string;
}

const useDateTimeCell = (props: DateTimeCellProps): ViewProps => {
    const date = props.date ? format(new Date(props.date), 'dd/MM/yyyy') : 'Unknown';
    const time = props.displayTime && props.date ? format(new Date(props.date), '• HH:mm') : 'Unknown';
    return {
        date,
        time
    };
};

export default useDateTimeCell;
